/** The search of `/time-entries/approvals`: the teams whose hours it lists (`AM-543`). */
export interface TimeApprovalsSearch {
  teams?: string;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * `?teams=` (C02-45): the identifiers of the teams, comma-separated, whose members' hours the queue lists,
 * as "Ver todo" of the card "Horas pendientes de aprobación" of the team leader opens it: the hours the card
 * counts. Anything that is not a list of identifiers is dropped, never thrown on.
 */
export function timeApprovalsSearchSchema(search: Record<string, unknown>): TimeApprovalsSearch {
  const teams = search['teams'];
  if (typeof teams !== 'string') {
    return {};
  }

  const ids = teams.split(',').filter((id) => id.length > 0);
  return ids.length > 0 && ids.every((id) => UUID.test(id)) ? { teams: ids.join(',') } : {};
}
